import { useContext } from "react";
import { UnitItemContext } from "@/context/UnitItemContext";

export const useUnitItemContext = () => {
    const context = useContext(UnitItemContext);
    if (!context) {
        throw new Error(
            "useUnitItemContext must be used within a UnitItemContext.Provider",
        );
    }
    return context;
};
